import { selectHasChangesInDraft } from "@/store/revisions-selector";
import { useAppSelector } from "@/store/store-hooks";
import { GUID } from "@faro-lotv/foundation";

/**
 * @returns True if the current project has a draft in progress
 * @param projectId The id of the current project
 */
export function useHasDraftInProgress(projectId: GUID | undefined): boolean {
  const hasChangesInDraft = useAppSelector(selectHasChangesInDraft);

  return !!projectId && hasChangesInDraft;
}
